"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _ComponentData2 = _interopRequireDefault(require("./ComponentData"));

var _GradeTypeConstants = _interopRequireDefault(require("../../constants/GradeTypeConstants"));

var YesNoData =
/*#__PURE__*/
function (_ComponentData) {
  (0, _inherits2.default)(YesNoData, _ComponentData);

  function YesNoData() {
    (0, _classCallCheck2.default)(this, YesNoData);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(YesNoData).apply(this, arguments));
  }

  (0, _createClass2.default)(YesNoData, [{
    key: "setGradeType",
    value: function setGradeType(grade) {
      if (this.resultGradeFlip) {
        // Nand the result as a 'true' value grade is not always positive
        grade = !(this.resultGradeFlip && grade);
      } // If 'grade' is true, that's good


      this.gradeType = grade ? _GradeTypeConstants.default.GOOD : _GradeTypeConstants.default.BAD;
    }
  }, {
    key: "setDisplayValue",
    value: function setDisplayValue() {
      var yesText = _I18n.default.text('results.data.yep');

      var noText = _I18n.default.text('results.data.nah');

      this.displayValue = this.gradeType === _GradeTypeConstants.default.BAD && this.resultGradeFlip ? yesText : noText;
      this.displayRecommendationValue = this.resultGradeFlip ? noText : yesText;
    }
  }]);
  return YesNoData;
}(_ComponentData2.default);

var _default = YesNoData;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/data/components/YesNoData.js
// module id = 63
// module chunks = 0